import { SHOW_SNACKBAR, HIDE_SNACKBAR } from './types';

export const showSnackbar = snackbar => ({
    type: SHOW_SNACKBAR,
    payload: snackbar,
});

export const hideSnackbar = snackbarId => ({
    type: HIDE_SNACKBAR,
    payload: snackbarId,
});
